import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/6/thumb-landscape.jpg"

const Post6 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          季節の変わり目はクローゼットの前で「去年は何を着てたんだっけ？」と途方にくれることもしばしば。まだ暑いけれど、夏らしい服装はもうできないし…と頭を悩ませますよね？<br/><br/>今回ご紹介するバッグは夏のコーデにも合わせやすいものばかりです。本格的に寒くなる前に、秋らしいファッションに切り替えたい方は、まずはバッグから変えてみましょう！
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-two-cloumn">
          <h2>色とサイズは<br className="pc"></br>大きくわけて3パターン</h2>
          <p>暑い時期はあまり選ばれないダークカラーの人気が復活する傾向です。ブラック・ブラウン・ダークブルーが人気の3大カラーと判明しました！今回ご紹介するバッグの色とサイズの傾向を詳しく説明していきます。</p>
        </div>
        <div className="text-max-width">
          <h2>ブラック</h2>
          <p>サイズは大きくわけて2パターン。A4サイズも余裕で入る大きめサイズか、おでかけワンピや日常使いもできる小さめサイズです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/1.jpg" alt="" />
        </figure>
        <div className="text-max-width">
          <h2>大きめサイズ</h2>
          <p>この2点の共通点はレザーじゃないこと！まだまだ、気温が高めの秋口は、ブラックの大きなレザーバッグでは重い印象になりがちです。</p>
        </div>
        <div className="text-max-width">
          <h2>Stella McCartney ファラベラ /36x36x8cm(幅x高さxマチ)</h2>       
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/2.jpg" alt="" />
        </figure>
        <p className="text-max-width">Stella McCartney／ステラマッカートニーは、どこよりも早く動物愛護や環境保護に取り組んできたブランド。リアルレザーなど動物性の素材を使っていないのが特徴です。</p>
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
        ステラマッカートニーのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>PRADA カナパ /35x24x22cm(幅x高さxマチ)</h2>       
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/3.jpg" alt="" />
        </figure>
        <p className="text-max-width">普段持ちできると好評のPRADA／プラダのカナパは、マチがたっぷりあり収納力抜群。しっかりしたキャンバス地で気兼ねなく使えます。</p>  
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
          プラダのバッグを見る
        </Link>                
        <div className="text-max-width">
          <h2>小さめサイズ</h2>
          <p>小さめサイズの2点はどちらもレザー素材。このサイズ感ならブラックのレザーバッグでも重い印象は避けられそうです。このサイズ感のバッグは、利用シーンが多彩なこともメリットです。</p>
        </div>
        <div className="text-max-width">
          <h2>Chloe ドリュー /18x16x7cm(幅x高さxマチ)</h2>       
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/4.jpg" alt="" />
        </figure>
        <p className="text-max-width">Chloe／クロエのドリューは、エレガントなスタイルからデニムなどのカジュアルスタイルまで幅広いコーデが可能。上品なバッグですが、貴重品だけ入れるような日常使いのメインバッグにするのもオススメです。</p>
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
          クロエのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>FENDI プチトロワジュール /22x17x10cm(幅x高さxマチ)</h2>       
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/5.jpg" alt="" />
        </figure>
        <p className="text-max-width">FENDI／フェンディのプチトロワジュールはトップハンドルとストラップの2WAY。構築的なデザインが印象的なハンドバッグです。</p>
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
          フェンディのバッグを見る
        </Link>          
        <div className="text-two-cloumn">
          <h2>ブラウン・ダークブルー</h2>
          <p>この2色は実用的な中サイズが揃います。大きさはほどほどでカラーもブラックほど重くないバランスの取れたタイプです。</p>
        </div>      
        <div className="text-max-width">
          <h2>ブラウンはモノグラムが人気</h2>
          <p>モノグラムとはルイ・ヴィトンの「モノグラム」だけでなく2つ以上の文字や記号を合わせた模様のことです。ブラウン系3種はすべてモノグラムでした。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/6.jpg" alt="" />
        </figure>
        <div className="text-max-width">
          <h2>GUCCI リバーシブル /28x21x11cm(幅x高さxマチ)</h2>       
        </div>        
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/7.jpg" alt="" />
        </figure>
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
          グッチのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>LOUIS VUITTON ネヴァーフルPM /29x22x13cm(幅x高さxマチ)</h2>       
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/8.jpg" alt="" />
        </figure>
        <div className="text-max-width">
          <h2>LOUIS VUITTON ヴェローナPM /28x22x15cm(幅x高さxマチ)</h2>       
        </div>                 
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/9.jpg" alt="" />
        </figure>
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
          ルイ・ヴィトンのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>ブルー系はカッチリタイプ</h2>
          <p>秋の装いと相性がいい落ち着いたブルー。どのバッグもハンドルとストラップがついた2WAYタイプです。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/10.jpg" alt="" />
        </figure>
        <div className="text-max-width">
          <h2>FENDI プチトゥージュール /23x17x11cm(幅x高さxマチ)</h2>       
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/11.jpg" alt="" />
        </figure>
        <div className="text-max-width">
          <h2>FENDI プチトゥージュール /23x17x11cm(幅x高さxマチ)</h2>       
        </div>         
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/12.jpg" alt="" />
        </figure>
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
          フェンディのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>PRADA サフィアーノ /28x20x12cm(幅x高さxマチ)</h2>       
        </div>        
        <figure className="img-small">
          <StaticImage src="../../images/posts/6/13.jpg" alt="" />
        </figure>                                        
        <Link to="https://laxus.co/app/pc/bags/stella" className="view-all-button">
          プラダのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post6

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 6}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
